"use client";
import { useContext, useEffect, useState } from "react";
import RangeSlider from "react-range-slider-input";
import { AppContext } from "./AppContext";
import { icons } from "./icons";

export default function HueBar() {
	const { config, bg, setBg, setConfig, hueRotation, setHueRotation } =
		useContext(AppContext);

	const [oConfig, setOConfig] = useState(false);
	const [oBg, setObg] = useState(false);
	const [isRunning, setIsRunning] = useState(false);

	useEffect(() => {
		if (!isRunning) {
			setOConfig(config);
			setObg(bg);
		}
	}, [config, bg, oConfig, oBg, isRunning]);

	const mutateColor = (c, r) => {
		let k = c.split("(")[1];
		k = k.split(",");
		let val = parseInt(k[0]);
		let newVal = val + r;
		newVal = newVal > 360 ? newVal - 360 : newVal;
		k.shift();
		let rest = k.join();
		newVal = "hsla(" + newVal + "," + rest;
		return newVal;
	};

	const onChange = (e) => {
		const r = e[1];
		setHueRotation(r);
		oBg && setBg(mutateColor(oBg, r));
		const newConfig = oConfig.map((c) => {
			const { colors } = c;
			const newColors = colors.map((color) => mutateColor(color, r));
			return { ...c, colors: newColors };
		});
		setConfig(newConfig);
	};

	return (
		<div className="border-color colorItem flex h-12 items-center gap-2 rounded border pl-1 pr-2">
			<div className="hu wu flexer">
				<div className="scale-75">{icons.hue}</div>
			</div>
			<div className="whitespace-nowrap">Hue Rotate</div>
			<div className="flex-1">
				<RangeSlider
					min={0}
					max={360}
					value={[0, hueRotation]}
					onInput={onChange}
					className="hAdjuster"
					onThumbDragStart={() => setIsRunning(true)}
					onThumbDragEnd={() => setIsRunning(false)}
				/>
			</div>
		</div>
	);
}
